import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import ProblemsSection from './components/ProblemsSection';
import ServicesOverview from './components/ServicesOverview';
import DetailedServices from './components/DetailedServices';
import About from './components/About';
import Team from './components/Team';
import KeyAreas from './components/KeyAreas';
import Blog from './components/Blog';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

const Landing = () => (
  <div className="bg-ivory text-ink min-h-screen">
    <Header />
    <main>
      <HeroCarousel />
      <ProblemsSection />
      <ServicesOverview />
      <DetailedServices />
      <About />
      <Team />
      <KeyAreas />
      <Blog />
      <ContactCTA />
    </main>
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
